<template>
  <div class="about">
    <combanner></combanner>
    <div class="about-upper com-upper-switch1 com-padding-top-30">
      <router-link :to="{name: 'feedback' }" class="dp-a1">
        <i class="iconfont icon-fankui"></i><b>用户反馈</b>
      </router-link>
      <router-link :to="{name: 'policy' }" class="dp-a1">
        <i class="iconfont icon-weibao"></i><b>维保政策</b>
      </router-link>
      <router-link :to="{name: 'network' }" class="dp-a1">
        <i class="iconfont icon-wangdian"></i><b>服务网点</b>
      </router-link>
      <router-link :to="{name: 'find' }" class="dp-a1">
        <i class="iconfont icon-zhaodaofind1"></i><b>如何找到我们</b>
      </router-link>
      <router-link :to="{name: 'distinguish' }" class="dp-a1">
        <i class="iconfont icon-tupianshibie"></i><b>如何识别皇冠工具</b>
      </router-link>
      <router-link :to="{name: 'guide' }" class="dp-a1">
        <i class="iconfont icon-zhinan"></i><b>工具使用指南</b>
      </router-link>
      <router-link :to="{name: 'download' }" class="dp-a1">
        <i class="iconfont icon-xiazai1"></i><b>下载中心</b>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">

</style>
